import { render, staticRenderFns } from "./BeneficiaryBenefitList.vue?vue&type=template&id=2e20ee0d&"
import script from "./benefit_list.js?vue&type=script&lang=js&"
export * from "./benefit_list.js?vue&type=script&lang=js&"
import style0 from "@/assets/styles/flexben_beneficiary.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports